(() => {
 const preference=matchMedia('(prefers-reduced-motion: reduce)');
 let chosen;try{chosen=sessionStorage.getItem('tw-motion');}catch(_){}
 const root=document.documentElement,toggle=document.querySelector('[data-motion-toggle]');
 function motion(enabled){root.dataset.motion=enabled?'on':'off';if(toggle){toggle.textContent=enabled?'Pause motion':'Play motion';toggle.removeAttribute('aria-label');toggle.removeAttribute('aria-pressed');}}
 motion(chosen?chosen==='on':!preference.matches);
 toggle?.addEventListener('click',()=>{const enabled=root.dataset.motion!=='on';chosen=enabled?'on':'off';try{sessionStorage.setItem('tw-motion',chosen);}catch(_){}motion(enabled);});
 preference.addEventListener('change',()=>{if(!chosen)motion(!preference.matches);});
 const lines=[...document.querySelectorAll('.inside-lines li')],arts=[...document.querySelectorAll('.inside-stage .art')];
 function show(i){lines.forEach((x,j)=>x.classList.toggle('on',j===i));arts.forEach((x,j)=>x.classList.toggle('on',j===i));}
 show(0);
 if('IntersectionObserver' in window){
   const story=new IntersectionObserver(entries=>entries.forEach(e=>{if(e.isIntersecting)show(lines.indexOf(e.target));}),{rootMargin:'-42% 0px -42% 0px'});lines.forEach(x=>story.observe(x));
 }
 // Keep copy visible. Photography and the continuous bands carry the motion.
 document.querySelectorAll('.rv').forEach(x=>x.classList.add('in'));
})();
